import { MerchantStatus } from '@nemuru-eng/js-api-client';

import { StatusTagType } from '../../../../config/types';

export const statusDefinitions = {
  [MerchantStatus.STATUS_ASLEEP]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'dark',
    SECTION_T_ID: MerchantStatus.STATUS_ASLEEP.toUpperCase(),
  },
  [MerchantStatus.STATUS_BANNED]: {
    colorPaletteName: StatusTagType.ERROR,
    colorType: 'main',
    SECTION_T_ID: MerchantStatus.STATUS_BANNED.toUpperCase(),
  },
  [MerchantStatus.STATUS_DENIED_EVALUATED]: {
    colorPaletteName: StatusTagType.ERROR,
    colorType: 'main',
    SECTION_T_ID: MerchantStatus.STATUS_DENIED_EVALUATED.toUpperCase(),
  },
  [MerchantStatus.STATUS_DENIED_PENDING_MANUAL]: {
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'dark',
    SECTION_T_ID: MerchantStatus.STATUS_DENIED_PENDING_MANUAL.toUpperCase(),
  },
  [MerchantStatus.STATUS_DOCUMENTS_COMPLETED]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'main',
    SECTION_T_ID: MerchantStatus.STATUS_DOCUMENTS_COMPLETED.toUpperCase(),
  },
  [MerchantStatus.STATUS_PENDING_DOCUMENTS]: {
    colorPaletteName: StatusTagType.INFO,
    colorType: 'main',
    SECTION_T_ID: MerchantStatus.STATUS_PENDING_DOCUMENTS.toUpperCase(),
  },
  [MerchantStatus.STATUS_PRE_APPROVED]: {
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'dark',
    SECTION_T_ID: MerchantStatus.STATUS_PRE_APPROVED.toUpperCase(),
  },
  [MerchantStatus.STATUS_SUSPENDED]: {
    colorPaletteName: StatusTagType.ERROR,
    colorType: 'main',
    SECTION_T_ID: MerchantStatus.STATUS_SUSPENDED.toUpperCase(),
  },
};
